// @ts-nocheck
import type { MultilingualQuestion } from '../../types/multilingualQuestion';

export const adasSafetyMultilingual: MultilingualQuestion[] = [
  // --- ISA ---
  {
    id: 'q-adas-1',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'Your car has Intelligent Speed Assistance (ISA). You are driving on a road where the speed limit has recently changed. What should you do?',
      nl: 'Jouw auto heeft Intelligente Snelheidsassistentie (ISA). Je rijdt op een weg waar de maximumsnelheid recentelijk is gewijzigd. Wat moet je doen?',
      ar: 'سيارتك مجهزة بنظام مساعدة السرعة الذكية (ISA). أنت تقود على طريق تغير فيه حد السرعة مؤخرا. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-1o1',
        text: {
          en: 'Trust ISA completely — it reads all speed signs automatically',
          nl: 'Vertrouw ISA volledig — het leest alle snelheidsborden automatisch',
          ar: 'ثق في ISA تماما — فهو يقرأ جميع لافتات السرعة تلقائيا',
        },
      },
      {
        id: 'q-adas-1o2',
        text: {
          en: 'Stay alert and check actual signs — ISA can misread temporary or faded signs',
          nl: 'Blijf alert en controleer de werkelijke borden — ISA kan tijdelijke of vervaagde borden verkeerd lezen',
          ar: 'ابق يقظا وتحقق من اللافتات الفعلية — قد يخطئ ISA في قراءة اللافتات المؤقتة أو الباهتة',
        },
      },
      {
        id: 'q-adas-1o3',
        text: {
          en: 'Turn off ISA when you see a new speed sign',
          nl: 'Schakel ISA uit wanneer je een nieuw snelheidsbord ziet',
          ar: 'أوقف تشغيل ISA عند رؤية لافتة سرعة جديدة',
        },
      },
    ],
    correctAnswerId: 'q-adas-1o2',
    explanation: {
      en: 'ISA uses cameras and GPS to read speed limits, but it can misread temporary signs, roadworks limits, or faded markings. You must always check the actual signs and remain responsible for your speed.',
      nl: 'ISA gebruikt camera\'s en GPS om snelheidslimieten te lezen, maar kan tijdelijke borden, werkzaamheden-limieten of vervaagde markeringen verkeerd lezen. Controleer altijd de werkelijke borden — jij blijft verantwoordelijk voor je snelheid.',
      ar: 'يستخدم ISA الكاميرات ونظام GPS لقراءة حدود السرعة، لكنه قد يخطئ في قراءة اللافتات المؤقتة أو حدود مناطق الأعمال أو العلامات الباهتة. يجب عليك دائما التحقق من اللافتات الفعلية والبقاء مسؤولا عن سرعتك.',
    },
  },
  {
    id: 'q-adas-2',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'ISA in your vehicle is warning you that you are exceeding the speed limit, but you believe the limit on this road is higher. What is the correct action?',
      nl: 'De ISA in jouw voertuig waarschuwt je dat je de maximumsnelheid overschrijdt, maar je denkt dat de limiet op deze weg hoger is. Wat is de juiste actie?',
      ar: 'يحذرك نظام ISA في سيارتك من تجاوز حد السرعة، لكنك تعتقد أن الحد في هذا الطريق أعلى. ما هو الإجراء الصحيح؟',
    },
    options: [
      {
        id: 'q-adas-2o1',
        text: {
          en: 'Override ISA and trust your own judgement, but verify the limit on the next sign',
          nl: 'Negeer ISA en vertrouw op eigen oordeel, maar controleer de limiet bij het volgende bord',
          ar: 'تجاوز ISA وثق بحكمك الخاص، لكن تحقق من الحد عند اللافتة التالية',
        },
      },
      {
        id: 'q-adas-2o2',
        text: {
          en: 'Always follow ISA — it is legally binding',
          nl: 'Volg altijd ISA — het heeft wettelijke bindende kracht',
          ar: 'اتبع ISA دائما — فهو ملزم قانونيا',
        },
      },
      {
        id: 'q-adas-2o3',
        text: {
          en: 'Switch ISA off permanently so it stops intervening',
          nl: 'Schakel ISA permanent uit zodat het stopt met ingrijpen',
          ar: 'أوقف تشغيل ISA بشكل دائم حتى لا يتدخل',
        },
      },
    ],
    correctAnswerId: 'q-adas-2o1',
    explanation: {
      en: 'ISA is a driver assistance tool, not a legal authority. You can override it, but you must verify the correct speed limit from road signs. You remain responsible for complying with the actual limit.',
      nl: 'ISA is een rijassistentie-hulpmiddel, geen wettelijke autoriteit. Je kunt het negeren, maar je moet de juiste snelheidslimiet verificeren via verkeersborden. Jij blijft verantwoordelijk voor naleving van de werkelijke limiet.',
      ar: 'ISA أداة مساعدة للسائق وليس سلطة قانونية. يمكنك تجاوزه، لكن يجب التحقق من حد السرعة الصحيح من لافتات الطريق. تظل مسؤولا عن الامتثال للحد الفعلي.',
    },
  },

  // --- AEB ---
  {
    id: 'q-adas-3',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-1-aeb-heavy-rain-braking.jpg',
    text: {
      en: 'You are driving at 80 km/h in heavy rain. Your car has Autonomous Emergency Braking (AEB). A car brakes suddenly ahead. What should you do?',
      nl: 'Je rijdt 80 km/u bij hevige regen. Jouw auto heeft Autonome Noodremmen (AEB). Een auto remt plotseling voor je. Wat moet je doen?',
      ar: 'أنت تقود بسرعة 80 كم/ساعة في مطر غزير. سيارتك مجهزة بنظام الفرملة الطارئة الذاتية (AEB). فجأة فرم سيارة أمامك. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-3o1',
        text: {
          en: 'Rely on AEB to stop the car — it works in all conditions',
          nl: 'Vertrouw op AEB om de auto te stoppen — het werkt in alle omstandigheden',
          ar: 'اعتمد على AEB لإيقاف السيارة — فهو يعمل في جميع الظروف',
        },
      },
      {
        id: 'q-adas-3o2',
        text: {
          en: 'Brake immediately yourself — AEB performance is reduced in heavy rain',
          nl: 'Rem zelf onmiddellijk — de werking van AEB is verminderd bij hevige regen',
          ar: 'فرم بنفسك فورا — أداء AEB ينخفض في حالة المطر الغزير',
        },
      },
      {
        id: 'q-adas-3o3',
        text: {
          en: 'Steer around the car and let AEB handle braking',
          nl: 'Stuur om de auto heen en laat AEB het remmen afhandelen',
          ar: 'انحرف حول السيارة ودع AEB يتولى الفرملة',
        },
      },
    ],
    correctAnswerId: 'q-adas-3o2',
    explanation: {
      en: 'AEB uses cameras and radar that can be impaired by heavy rain, snow, or dirt on sensors. Always maintain a safe following distance and brake yourself — do not rely solely on AEB to prevent a collision.',
      nl: 'AEB gebruikt camera\'s en radar die kunnen worden beïnvloed door hevige regen, sneeuw of vuil op de sensoren. Houd altijd een veilige volgafstand en rem zelf — vertrouw niet uitsluitend op AEB om een botsing te voorkomen.',
      ar: 'يستخدم AEB الكاميرات والرادار التي قد تتأثر بالمطر الغزير أو الثلج أو الأوساخ على أجهزة الاستشعار. احتفظ دائما بمسافة أمان كافية وفرم بنفسك — لا تعتمد على AEB وحده لمنع الاصطدام.',
    },
  },
  {
    id: 'q-adas-4',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'AEB activates unexpectedly on an open road with no obstacle. What is the most likely cause?',
      nl: 'AEB activeert onverwacht op een open weg zonder obstakel. Wat is de meest waarschijnlijke oorzaak?',
      ar: 'يتفعل AEB بشكل غير متوقع على طريق مفتوح بدون عائق. ما هو السبب الأرجح؟',
    },
    options: [
      {
        id: 'q-adas-4o1',
        text: {
          en: 'The system is malfunctioning and you should have it checked',
          nl: 'Het systeem werkt niet goed en je moet het laten controleren',
          ar: 'النظام يعمل بشكل خاطئ ويجب فحصه',
        },
      },
      {
        id: 'q-adas-4o2',
        text: {
          en: 'A dirty or obscured sensor is triggering a false reading',
          nl: 'Een vuile of geblokkeerde sensor veroorzaakt een valse detectie',
          ar: 'مستشعر متسخ أو محجوب يسبب قراءة خاطئة',
        },
      },
      {
        id: 'q-adas-4o3',
        text: {
          en: 'Both A and B are possible — have the sensors cleaned and the system inspected',
          nl: 'Beide A en B zijn mogelijk — laat de sensoren reinigen en het systeem inspecteren',
          ar: 'كلا الخيارين A وB ممكنان — قم بتنظيف أجهزة الاستشعار وفحص النظام',
        },
      },
    ],
    correctAnswerId: 'q-adas-4o3',
    explanation: {
      en: 'False AEB activations can be caused by dirty sensors, sun glare, overhanging branches, or a system fault. Always clean sensors regularly and have unexpected activations inspected by a mechanic.',
      nl: 'Valse AEB-activeringen kunnen worden veroorzaakt door vuile sensoren, zonlichtgloed, overhangende takken of een systeemfout. Reinig sensoren regelmatig en laat onverwachte activeringen door een monteur inspecteren.',
      ar: 'يمكن أن تحدث أعطال AEB الكاذبة بسبب مستشعرات متسخة أو وهج الشمس أو الأغصان المتدلية أو خلل في النظام. نظف أجهزة الاستشعار بانتظام وافحص الأعطال غير المتوقعة لدى ميكانيكي.',
    },
  },

  // --- ACC ---
  {
    id: 'q-adas-5',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-6-acc-safe-distance.jpg',
    text: {
      en: 'You are using Adaptive Cruise Control (ACC) on a motorway. Traffic suddenly stops ahead due to a collision. What must you do?',
      nl: 'Je gebruikt Adaptieve Cruise Control (ACC) op de snelweg. Verkeer stopt plotseling voor je door een aanrijding. Wat moet je doen?',
      ar: 'تستخدم نظام التحكم في السرعة التكيفي (ACC) على الطريق السريع. تتوقف حركة المرور فجأة أمامك بسبب حادث. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-5o1',
        text: {
          en: 'Nothing — ACC will bring the car to a full stop automatically in all situations',
          nl: 'Niets — ACC brengt de auto in alle situaties automatisch tot stilstand',
          ar: 'لا شيء — سيوقف ACC السيارة تلقائيا في جميع المواقف',
        },
      },
      {
        id: 'q-adas-5o2',
        text: {
          en: 'Take over immediately — ACC may not detect a full stop quickly enough at high speed',
          nl: 'Grijp onmiddellijk in — ACC kan een volledige stop mogelijk niet snel genoeg detecteren bij hoge snelheid',
          ar: 'تدخل فورا — قد لا يكتشف ACC التوقف التام بسرعة كافية عند السرعات العالية',
        },
      },
      {
        id: 'q-adas-5o3',
        text: {
          en: 'Sound your horn to warn other drivers while ACC handles braking',
          nl: 'Toeter om andere bestuurders te waarschuwen terwijl ACC het remmen afhandelt',
          ar: 'استخدم البوق لتحذير السائقين الآخرين بينما يتولى ACC الفرملة',
        },
      },
    ],
    correctAnswerId: 'q-adas-5o2',
    explanation: {
      en: 'ACC maintains a set following distance but has limitations, especially at high speed or in sudden stop situations. You must always be prepared to take over immediately. ACC does not replace attentive driving.',
      nl: 'ACC handhaaft een ingestelde volgafstand maar heeft beperkingen, vooral bij hoge snelheid of plotselinge stopsituaties. Wees altijd bereid onmiddellijk over te nemen. ACC vervangt geen oplettend rijden.',
      ar: 'يحافظ ACC على مسافة متابعة محددة لكن له قيود، خاصة عند السرعات العالية أو في مواقف التوقف المفاجئ. يجب أن تكون مستعدا دائما للتدخل الفوري. لا يغني ACC عن القيادة المنتبهة.',
    },
  },
  {
    id: 'q-adas-6',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-7-acc-wet-road.jpg',
    text: {
      en: 'You are driving with ACC set to 120 km/h on a wet motorway. Why should you manually reduce speed?',
      nl: 'Je rijdt met ACC ingesteld op 120 km/u op een natte snelweg. Waarom moet je de snelheid handmatig verlagen?',
      ar: 'أنت تقود مع ACC مضبوطا على 120 كم/ساعة على طريق سريع مبلل. لماذا يجب عليك تخفيض السرعة يدويا؟',
    },
    options: [
      {
        id: 'q-adas-6o1',
        text: {
          en: 'ACC automatically adjusts speed for road conditions',
          nl: 'ACC past de snelheid automatisch aan op rijomstandigheden',
          ar: 'يعدل ACC السرعة تلقائيا وفقا لأحوال الطريق',
        },
      },
      {
        id: 'q-adas-6o2',
        text: {
          en: 'ACC maintains your set speed regardless of road conditions — you must reduce it manually',
          nl: 'ACC handhaaft jouw ingestelde snelheid ongeacht de rijomstandigheden — je moet deze handmatig verlagen',
          ar: 'يحافظ ACC على سرعتك المضبوطة بغض النظر عن أحوال الطريق — يجب عليك تخفيضها يدويا',
        },
      },
      {
        id: 'q-adas-6o3',
        text: {
          en: 'ACC is not allowed on wet roads under Dutch law',
          nl: 'ACC is niet toegestaan op natte wegen volgens de Nederlandse wet',
          ar: 'لا يسمح باستخدام ACC على الطرق المبللة بموجب القانون الهولندي',
        },
      },
    ],
    correctAnswerId: 'q-adas-6o2',
    explanation: {
      en: 'ACC does not detect road surface conditions such as rain, ice, or aquaplaning risk. It maintains the set speed unless it detects a slower vehicle ahead. You are responsible for setting an appropriate speed for conditions.',
      nl: 'ACC detecteert geen wegdekconditie zoals regen, ijs of aquaplaningrisico. Het handhaaft de ingestelde snelheid tenzij het een trager voertuig voor je detecteert. Jij bent verantwoordelijk voor het instellen van een passende snelheid voor de omstandigheden.',
      ar: 'لا يكتشف ACC أحوال سطح الطريق مثل المطر أو الجليد أو خطر الانزلاق المائي. يحافظ على السرعة المضبوطة ما لم يكتشف مركبة أبطأ أمامك. أنت مسؤول عن ضبط سرعة مناسبة لظروف الطريق.',
    },
  },

  // --- Lane Keeping Assist / LDW ---
  {
    id: 'q-adas-7',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-3-lka-clear-markings.jpg',
    text: {
      en: 'Lane Keeping Assist (LKA) stops working and a warning light appears. You are on a motorway. What should you do?',
      nl: 'Rijstrookassistent (LKA) stopt met werken en een waarschuwingslampje verschijnt. Je rijdt op de snelweg. Wat moet je doen?',
      ar: 'يتوقف نظام مساعدة الحفاظ على المسار (LKA) عن العمل وتظهر لمبة تحذير. أنت على الطريق السريع. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-7o1',
        text: {
          en: 'Pull over immediately — driving without LKA is illegal',
          nl: 'Stop onmiddellijk — rijden zonder LKA is illegaal',
          ar: 'توقف فورا — القيادة بدون LKA غير قانونية',
        },
      },
      {
        id: 'q-adas-7o2',
        text: {
          en: 'Continue driving attentively without relying on LKA and have it checked soon',
          nl: 'Rij aandachtig verder zonder op LKA te vertrouwen en laat het binnenkort controleren',
          ar: 'استمر في القيادة بانتباه دون الاعتماد على LKA وافحصه في أقرب وقت',
        },
      },
      {
        id: 'q-adas-7o3',
        text: {
          en: 'Increase speed so you rely on LKA less',
          nl: 'Verhoog de snelheid zodat je minder afhankelijk bent van LKA',
          ar: 'زد السرعة حتى تعتمد على LKA أقل',
        },
      },
    ],
    correctAnswerId: 'q-adas-7o2',
    explanation: {
      en: 'LKA is a driving aid, not a legal requirement. If it fails, continue driving with full manual attention and have the system checked at the next opportunity. You must always be capable of driving safely without driver assistance systems.',
      nl: 'LKA is een rijhulpmiddel, geen wettelijke vereiste. Als het uitvalt, rijd dan met volledige handmatige aandacht en laat het systeem bij de eerstvolgende gelegenheid controleren. Je moet altijd in staat zijn veilig te rijden zonder rijassistentiesystemen.',
      ar: 'LKA مساعد قيادة وليس متطلبا قانونيا. إذا تعطل، استمر في القيادة بانتباه كامل يدوي وافحص النظام في أول فرصة. يجب أن تكون دائما قادرا على القيادة بأمان دون أنظمة مساعدة السائق.',
    },
  },
  {
    id: 'q-adas-8',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-4-lka-obscured-snow.jpg',
    text: {
      en: 'You are driving in heavy snow. Your Lane Departure Warning (LDW) system has switched off automatically. Why?',
      nl: 'Je rijdt bij zware sneeuwval. Je Rijstrookafwijkingswaarschuwing (LDW) is automatisch uitgeschakeld. Waarom?',
      ar: 'أنت تقود في ثلج كثيف. انطفأ نظام تحذير مغادرة المسار (LDW) تلقائيا. لماذا؟',
    },
    options: [
      {
        id: 'q-adas-8o1',
        text: {
          en: 'Snow has covered the lane markings the camera uses to detect lane position',
          nl: 'Sneeuw heeft de rijstrookmarkeringen bedekt die de camera gebruikt om de rijstrookpositie te detecteren',
          ar: 'غطى الثلج علامات المسار التي تستخدمها الكاميرا للكشف عن موضع المسار',
        },
      },
      {
        id: 'q-adas-8o2',
        text: {
          en: 'Cold weather causes the system to shut down to save battery',
          nl: 'Koud weer zorgt ervoor dat het systeem afsluit om de accu te sparen',
          ar: 'يتسبب الطقس البارد في إيقاف تشغيل النظام لتوفير البطارية',
        },
      },
      {
        id: 'q-adas-8o3',
        text: {
          en: 'Dutch law requires LDW to be off in winter conditions',
          nl: 'De Nederlandse wet vereist dat LDW is uitgeschakeld in winterse omstandigheden',
          ar: 'يشترط القانون الهولندي إيقاف تشغيل LDW في ظروف الشتاء',
        },
      },
    ],
    correctAnswerId: 'q-adas-8o1',
    explanation: {
      en: 'LDW and LKA rely on cameras to detect lane markings. Snow, mud, heavy rain, or faded road markings can make lane detection impossible, causing the system to deactivate. Increase your own attention in these conditions.',
      nl: 'LDW en LKA vertrouwen op camera\'s om rijstrookmarkeringen te detecteren. Sneeuw, modder, hevige regen of vervaagde wegmarkeringen kunnen rijstrookdetectie onmogelijk maken, waardoor het systeem deactiveert. Verhoog jouw eigen aandacht in deze omstandigheden.',
      ar: 'يعتمد LDW وLKA على الكاميرات للكشف عن علامات المسار. يمكن أن يجعل الثلج أو الوحل أو المطر الغزير أو علامات الطريق الباهتة الكشف عن المسار مستحيلا، مما يتسبب في إيقاف تشغيل النظام. زد انتباهك الخاص في هذه الظروف.',
    },
  },

  // --- Blind Spot Monitoring ---
  {
    id: 'q-adas-9',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'Your Blind Spot Monitoring (BSM) system shows no warning when you want to change lanes. What must you still do?',
      nl: 'Je Dodehoekbewaking (BSM) toont geen waarschuwing wanneer je van rijstrook wilt wisselen. Wat moet je toch nog doen?',
      ar: 'لا يظهر نظام مراقبة النقطة العمياء (BSM) أي تحذير عندما تريد تغيير المسار. ماذا يجب أن تفعل رغم ذلك؟',
    },
    options: [
      {
        id: 'q-adas-9o1',
        text: {
          en: 'Change lanes — BSM has confirmed the lane is clear',
          nl: 'Verander van rijstrook — BSM heeft bevestigd dat de rijstrook vrij is',
          ar: 'غير المسار — BSM أكد أن المسار خال',
        },
      },
      {
        id: 'q-adas-9o2',
        text: {
          en: 'Check your mirrors and look over your shoulder before changing lanes',
          nl: 'Controleer je spiegels en kijk over je schouder voordat je van rijstrook wisselt',
          ar: 'تحقق من مرايا سيارتك وانظر خلف كتفك قبل تغيير المسار',
        },
      },
      {
        id: 'q-adas-9o3',
        text: {
          en: 'Sound your horn to warn other road users first',
          nl: 'Toeter eerst om andere weggebruikers te waarschuwen',
          ar: 'استخدم البوق أولا لتحذير مستخدمي الطريق الآخرين',
        },
      },
    ],
    correctAnswerId: 'q-adas-9o2',
    explanation: {
      en: 'BSM assists but cannot detect all situations — fast-approaching vehicles, cyclists, or motorcycles may not trigger the warning in time. Always check mirrors and your blind spot physically before every lane change.',
      nl: 'BSM helpt maar kan niet alle situaties detecteren — snel naderende voertuigen, fietsers of motorrijders activeren de waarschuwing mogelijk niet op tijd. Controleer altijd spiegels en je dode hoek fysiek voor elke rijstrookwissel.',
      ar: 'يساعد BSM لكنه لا يستطيع الكشف عن جميع المواقف — قد لا تشغل المركبات أو الدراجات الهوائية أو الدراجات النارية التي تقترب بسرعة التحذير في الوقت المناسب. تحقق دائما من المرايا والنقطة العمياء جسديا قبل كل تغيير مسار.',
    },
  },
  {
    id: 'q-adas-10',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'A cyclist is in your right blind spot. Your BSM warning light is showing. What should you do?',
      nl: 'Een fietser bevindt zich in je rechter dode hoek. Je BSM-waarschuwingslampje brandt. Wat moet je doen?',
      ar: 'يوجد دراج في نقطتك العمياء اليمنى. تضيء لمبة تحذير BSM. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-10o1',
        text: {
          en: 'Wait for the BSM warning to disappear before turning right',
          nl: 'Wacht tot de BSM-waarschuwing verdwijnt voordat je rechtsaf slaat',
          ar: 'انتظر حتى يختفي تحذير BSM قبل الانعطاف يمينا',
        },
      },
      {
        id: 'q-adas-10o2',
        text: {
          en: 'Look over your shoulder to confirm before proceeding — BSM may not detect cyclists reliably',
          nl: 'Kijk over je schouder ter bevestiging voordat je verder gaat — BSM detecteert fietsers mogelijk niet betrouwbaar',
          ar: 'انظر خلف كتفك للتأكيد قبل المتابعة — قد لا يكتشف BSM الدراجين بموثوقية',
        },
      },
      {
        id: 'q-adas-10o3',
        text: {
          en: 'Tap your brakes to warn the cyclist, then turn',
          nl: 'Tik kort op de rem om de fietser te waarschuwen, sla dan af',
          ar: 'اضغط على الفرامل لتحذير الدراج، ثم انعطف',
        },
      },
    ],
    correctAnswerId: 'q-adas-10o2',
    explanation: {
      en: 'BSM warnings are helpful but not definitive. Some systems may not reliably detect cyclists or motorcycles. Always physically check your blind spot, especially when turning or changing lanes near vulnerable road users.',
      nl: 'BSM-waarschuwingen zijn nuttig maar niet definitief. Sommige systemen detecteren fietsers of motorrijders mogelijk niet betrouwbaar. Controleer je dode hoek altijd fysiek, vooral bij het afslaan of rijstrook wisselen nabij kwetsbare weggebruikers.',
      ar: 'تحذيرات BSM مفيدة لكنها ليست قاطعة. قد لا تكتشف بعض الأنظمة الدراجين أو الدراجات النارية بموثوقية. تحقق دائما من نقطتك العمياء جسديا، خاصة عند الانعطاف أو تغيير المسار بالقرب من مستخدمي الطريق الضعفاء.',
    },
  },

  // --- TPMS ---
  {
    id: 'q-adas-13',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'The TPMS (Tire Pressure Monitoring System) warning light comes on while driving. What should you do?',
      nl: 'Het TPMS-waarschuwingslampje (Bandenspanningsmeetssysteem) gaat aan tijdens het rijden. Wat moet je doen?',
      ar: 'تضيء لمبة تحذير نظام مراقبة ضغط الإطارات (TPMS) أثناء القيادة. ماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-13o1',
        text: {
          en: 'Continue driving — the system monitors itself and will alert you if pressure becomes critical',
          nl: 'Rijd door — het systeem controleert zichzelf en waarschuwt je als de druk kritiek wordt',
          ar: 'استمر في القيادة — النظام يراقب نفسه وسينبهك إذا أصبح الضغط حرجا',
        },
      },
      {
        id: 'q-adas-13o2',
        text: {
          en: 'Reduce speed, check tire pressure at the earliest opportunity, and do not drive long distances on a significantly under-inflated tire',
          nl: 'Verlaag snelheid, controleer de bandenspanning bij de eerste gelegenheid en rij geen lange afstanden op een sterk ondergespannen band',
          ar: 'خفض السرعة وتحقق من ضغط الإطارات في أقرب فرصة، ولا تقود مسافات طويلة على إطار منخفض الضغط بشكل ملحوظ',
        },
      },
      {
        id: 'q-adas-13o3',
        text: {
          en: 'Inflate all four tires at the next fuel station, regardless of current pressure',
          nl: 'Pomp alle vier banden op bij het volgende tankstation, ongeacht de huidige druk',
          ar: 'انفخ جميع الإطارات الأربعة في أول محطة وقود بغض النظر عن الضغط الحالي',
        },
      },
    ],
    correctAnswerId: 'q-adas-13o2',
    explanation: {
      en: 'A TPMS warning indicates at least one tire is significantly under-inflated, which affects braking, handling, and increases blowout risk. Reduce speed and check pressures promptly. Driving long distances on a flat can destroy the tire and rim.',
      nl: 'Een TPMS-waarschuwing geeft aan dat minstens één band significant ondergespannen is, wat remmen en besturing beïnvloedt en het risico op lekrijden vergroot. Verlaag de snelheid en controleer de druk snel. Rijden over grote afstanden op een lekke band kan de band en velg vernielen.',
      ar: 'يشير تحذير TPMS إلى أن إطارا واحدا على الأقل منخفض الضغط بشكل ملحوظ، مما يؤثر على الفرملة والتحكم ويزيد من خطر الانفجار. خفض السرعة وتحقق من الضغط فورا. يمكن أن تؤدي القيادة لمسافات طويلة على إطار مثقوب إلى تدمير الإطار والجنط.',
    },
  },

  // --- Driver Drowsiness Detection ---
  {
    id: 'q-adas-14',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-8-drowsiness-alert.jpg',
    text: {
      en: "Your car's drowsiness detection system gives a coffee cup warning. What does this mean and what should you do?",
      nl: 'Het slaperigheidsdetectiesysteem van je auto geeft een koffiekopje-waarschuwing. Wat betekent dit en wat moet je doen?',
      ar: 'يعطي نظام الكشف عن النعاس في سيارتك تحذير فنجان القهوة. ماذا يعني هذا وماذا يجب أن تفعل؟',
    },
    options: [
      {
        id: 'q-adas-14o1',
        text: {
          en: 'The system has detected driving patterns that suggest fatigue — stop at the nearest rest area and rest',
          nl: 'Het systeem heeft rijpatronen gedetecteerd die vermoeidheid suggereren — stop bij de dichtstbijzijnde rustplaats en rust uit',
          ar: 'اكتشف النظام أنماط قيادة تدل على التعب — توقف في أقرب منطقة استراحة واسترح',
        },
      },
      {
        id: 'q-adas-14o2',
        text: {
          en: 'You need to refuel — the icon resembles a fuel pump',
          nl: 'Je moet tanken — het pictogram lijkt op een brandstofpomp',
          ar: 'تحتاج إلى التزود بالوقود — الأيقونة تشبه مضخة الوقود',
        },
      },
      {
        id: 'q-adas-14o3',
        text: {
          en: 'You are driving too fast — reduce speed immediately',
          nl: 'Je rijdt te hard — verlaag onmiddellijk de snelheid',
          ar: 'أنت تقود بسرعة كبيرة — خفض السرعة فورا',
        },
      },
    ],
    correctAnswerId: 'q-adas-14o1',
    explanation: {
      en: 'A coffee cup icon from the drowsiness detection system indicates the system has detected steering patterns or driving behaviour associated with fatigue. Stop safely and rest. Fatigue is a major cause of serious accidents.',
      nl: 'Een koffiekopje-pictogram van het slaperigheidsdetectiesysteem geeft aan dat het systeem stuurpatronen of rijgedrag heeft gedetecteerd dat verband houdt met vermoeidheid. Stop veilig en rust uit. Vermoeidheid is een belangrijke oorzaak van ernstige ongelukken.',
      ar: 'يشير أيقونة فنجان القهوة من نظام الكشف عن النعاس إلى أن النظام اكتشف أنماط توجيه أو سلوك قيادة مرتبط بالتعب. توقف بأمان واسترح. التعب سبب رئيسي للحوادث الخطيرة.',
    },
  },
  {
    id: 'q-adas-15',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'You feel fine but the drowsiness alert keeps triggering. What is the safest response?',
      nl: 'Je voelt je goed maar de slaperigheidswaarschuwing blijft afgaan. Wat is de veiligste reactie?',
      ar: 'تشعر بأنك بخير لكن تحذير النعاس يستمر في الظهور. ما هو الرد الأكثر أمانا؟',
    },
    options: [
      {
        id: 'q-adas-15o1',
        text: {
          en: 'Ignore it — the system is faulty if you do not feel tired',
          nl: 'Negeer het — het systeem is defect als je je niet moe voelt',
          ar: 'تجاهله — النظام معطوب إذا لم تشعر بالتعب',
        },
      },
      {
        id: 'q-adas-15o2',
        text: {
          en: 'Take a break anyway — the system can detect micro-fatigue before you are consciously aware of it',
          nl: 'Neem toch een pauze — het systeem kan micro-vermoeidheid detecteren voordat je je daar bewust van bent',
          ar: 'خذ استراحة على أي حال — يمكن للنظام اكتشاف التعب الدقيق قبل أن تشعر به بشكل واع',
        },
      },
      {
        id: 'q-adas-15o3',
        text: {
          en: 'Turn on the radio to stay alert and dismiss the warning',
          nl: 'Zet de radio aan om alert te blijven en negeer de waarschuwing',
          ar: 'شغل الراديو لتبقى يقظا وأغلق التحذير',
        },
      },
    ],
    correctAnswerId: 'q-adas-15o2',
    explanation: {
      en: 'Fatigue impairs judgement about your own alertness. The drowsiness system analyses driving patterns and can detect reduced performance before you feel tired. When in doubt, stop and rest — a 15-minute break significantly reduces fatigue.',
      nl: 'Vermoeidheid verslechtert het oordeel over je eigen alertheid. Het slaperigheidssysteem analyseert rijpatronen en kan verminderde prestaties detecteren voordat je moe voelt. Twijfel je, stop dan en rust uit — een pauze van 15 minuten vermindert vermoeidheid aanzienlijk.',
      ar: 'يضعف التعب الحكم على مدى يقظتك الخاصة. يحلل نظام النعاس أنماط القيادة ويمكنه اكتشاف انخفاض الأداء قبل أن تشعر بالتعب. عند الشك، توقف واسترح — استراحة 15 دقيقة تقلل التعب بشكل ملحوظ.',
    },
  },

  // --- Traffic Sign Recognition ---
  {
    id: 'q-adas-16',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-10-tsr-misread.jpg',
    text: {
      en: "Your car's Traffic Sign Recognition (TSR) displays a 30 km/h limit, but you can see a 50 km/h sign on the road. Which limit applies?",
      nl: 'De Verkeersbordherkenning (TSR) van je auto toont een limiet van 30 km/u, maar je ziet een bord van 50 km/u op de weg. Welke limiet geldt?',
      ar: 'يعرض نظام التعرف على إشارات المرور (TSR) في سيارتك حدا يبلغ 30 كم/ساعة، لكنك ترى لافتة 50 كم/ساعة على الطريق. أي حد يطبق؟',
    },
    options: [
      {
        id: 'q-adas-16o1',
        text: {
          en: 'The TSR display — it reads signs more accurately than human eyes',
          nl: 'Het TSR-display — het leest borden nauwkeuriger dan menselijke ogen',
          ar: 'شاشة TSR — فهي تقرأ اللافتات بدقة أكبر من العيون البشرية',
        },
      },
      {
        id: 'q-adas-16o2',
        text: {
          en: 'The actual road sign — TSR can misread signs and you must always follow the physical sign',
          nl: 'Het werkelijke verkeersbord — TSR kan borden verkeerd lezen en je moet altijd het fysieke bord volgen',
          ar: 'لافتة الطريق الفعلية — قد يخطئ TSR في قراءة اللافتات ويجب عليك دائما اتباع اللافتة المادية',
        },
      },
      {
        id: 'q-adas-16o3',
        text: {
          en: 'The lower limit — always choose the safer option when systems disagree',
          nl: 'De lagere limiet — kies altijd de veiligere optie als systemen het oneens zijn',
          ar: 'الحد الأدنى — اختر دائما الخيار الأكثر أمانا عندما تختلف الأنظمة',
        },
      },
    ],
    correctAnswerId: 'q-adas-16o2',
    explanation: {
      en: "TSR cameras can misread signs due to sun glare, dirt, angle, or sign damage. The physical road sign always takes legal precedence. You are responsible for obeying actual traffic signs, not your car's display.",
      nl: 'TSR-camera\'s kunnen borden verkeerd lezen door zonlichtgloed, vuil, hoek of bordschade. Het fysieke verkeersbord heeft altijd wettelijke voorrang. Jij bent verantwoordelijk voor het naleven van werkelijke verkeersborden, niet van het display van je auto.',
      ar: 'قد تخطئ كاميرات TSR في قراءة اللافتات بسبب وهج الشمس أو الأوساخ أو الزاوية أو تلف اللافتة. تأخذ لافتة الطريق المادية دائما الأسبقية القانونية. أنت مسؤول عن طاعة لافتات المرور الفعلية وليس شاشة سيارتك.',
    },
  },

  // --- Parking Sensors and Camera ---
  {
    id: 'q-adas-17',
    subject: 'ADAS & Safety Systems',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/adas-safety/adas-11-parking-camera.jpg',
    text: {
      en: 'You are reversing using only your 360° camera system. The system shows no obstacles. Is it safe to reverse?',
      nl: 'Je rijdt achteruit met alleen je 360°-camerasysteem. Het systeem toont geen obstakels. Is het veilig om achteruit te rijden?',
      ar: 'أنت تتراجع باستخدام نظام الكاميرا 360° فقط. لا يظهر النظام أي عوائق. هل الرجوع للخلف آمن؟',
    },
    options: [
      {
        id: 'q-adas-17o1',
        text: {
          en: 'Yes — 360° cameras show everything around the vehicle',
          nl: 'Ja — 360°-camera\'s tonen alles rondom het voertuig',
          ar: 'نعم — تظهر كاميرات 360° كل شيء حول المركبة',
        },
      },
      {
        id: 'q-adas-17o2',
        text: {
          en: 'Not necessarily — cameras have blind spots, lag, and may not detect low or fast-moving objects',
          nl: 'Niet noodzakelijk — camera\'s hebben dode hoeken, vertraging en detecteren mogelijk geen lage of snel bewegende objecten',
          ar: 'ليس بالضرورة — للكاميرات نقاط عمياء وتأخر وقد لا تكتشف الأشياء المنخفضة أو سريعة الحركة',
        },
      },
      {
        id: 'q-adas-17o3',
        text: {
          en: 'Only if your parking sensors also confirm it is clear',
          nl: 'Alleen als je parkeersensoren ook bevestigen dat het vrij is',
          ar: 'فقط إذا أكدت أجهزة استشعار الركن أيضا أنه خال',
        },
      },
    ],
    correctAnswerId: 'q-adas-17o2',
    explanation: {
      en: 'Camera and sensor systems have limitations — blind spots, poor performance in bright sunlight, slow refresh rates, and difficulty detecting small children or animals. Always physically check before reversing and move slowly.',
      nl: 'Camera- en sensorsystemen hebben beperkingen — dode hoeken, slechte prestaties in fel zonlicht, trage verversingssnelheden en moeite met het detecteren van kleine kinderen of dieren. Controleer altijd fysiek voordat je achteruitrijdt en beweeg langzaam.',
      ar: 'لأنظمة الكاميرا وأجهزة الاستشعار قيود — نقاط عمياء وأداء ضعيف في أشعة الشمس الساطعة ومعدلات تحديث بطيئة وصعوبة في اكتشاف الأطفال الصغار أو الحيوانات. تحقق دائما جسديا قبل الرجوع للخلف وتحرك ببطء.',
    },
  },

  // --- Driver Responsibility ---
  {
    id: 'q-adas-18',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'Your vehicle has Level 2 driver assistance (ACC + LKA active). You take your hands off the wheel and look at your phone. What is the legal position?',
      nl: 'Jouw voertuig heeft rijassistentie niveau 2 (ACC + LKA actief). Je neemt je handen van het stuur en kijkt naar je telefoon. Wat is de wettelijke positie?',
      ar: 'سيارتك مجهزة بمساعدة السائق من المستوى 2 (ACC + LKA نشط). تبعد يديك عن المقود وتنظر إلى هاتفك. ما هو الوضع القانوني؟',
    },
    options: [
      {
        id: 'q-adas-18o1',
        text: {
          en: 'You are not responsible — the system is driving the vehicle',
          nl: 'Je bent niet verantwoordelijk — het systeem bestuurt het voertuig',
          ar: 'لست مسؤولا — النظام يقود المركبة',
        },
      },
      {
        id: 'q-adas-18o2',
        text: {
          en: 'You are still fully responsible — Level 2 requires constant driver supervision and hands on the wheel',
          nl: 'Je bent nog steeds volledig verantwoordelijk — niveau 2 vereist voortdurend toezicht van de bestuurder en handen aan het stuur',
          ar: 'لا تزال مسؤولا بالكامل — المستوى 2 يتطلب إشراف السائق المستمر ووضع يديه على المقود',
        },
      },
      {
        id: 'q-adas-18o3',
        text: {
          en: 'You are only partially responsible if the system causes an accident',
          nl: 'Je bent slechts gedeeltelijk verantwoordelijk als het systeem een ongeluk veroorzaakt',
          ar: 'أنت مسؤول جزئيا فقط إذا تسبب النظام في حادث',
        },
      },
    ],
    correctAnswerId: 'q-adas-18o2',
    explanation: {
      en: 'Level 2 automation (ACC + LKA) requires the driver to remain in control at all times with hands on the wheel. The driver is fully legally responsible. Using a phone while driving is illegal regardless of which assistance systems are active.',
      nl: 'Niveau 2-automatisering (ACC + LKA) vereist dat de bestuurder te allen tijde de controle heeft met handen aan het stuur. De bestuurder is volledig wettelijk verantwoordelijk. Het gebruik van een telefoon tijdens het rijden is illegaal, ongeacht welke assistentiesystemen actief zijn.',
      ar: 'تتطلب أتمتة المستوى 2 (ACC + LKA) أن يحتفظ السائق بالتحكم في جميع الأوقات مع وضع يديه على المقود. السائق مسؤول قانونيا بالكامل. استخدام الهاتف أثناء القيادة غير قانوني بغض النظر عن أنظمة المساعدة النشطة.',
    },
  },
  {
    id: 'q-adas-19',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'A road user is injured in an accident where your ACC system failed to brake in time. Who is liable?',
      nl: 'Een weggebruiker raakt gewond bij een ongeluk waarbij je ACC-systeem niet op tijd remde. Wie is aansprakelijk?',
      ar: 'أصيب مستخدم طريق في حادث فشل فيه نظام ACC في الفرملة في الوقت المناسب. من المسؤول؟',
    },
    options: [
      {
        id: 'q-adas-19o1',
        text: {
          en: 'The car manufacturer, since the ADAS system failed',
          nl: 'De autofabrikant, omdat het ADAS-systeem heeft gefaald',
          ar: 'الشركة المصنعة للسيارة، لأن نظام ADAS فشل',
        },
      },
      {
        id: 'q-adas-19o2',
        text: {
          en: 'You as the driver — you remain responsible for maintaining a safe following distance at all times',
          nl: 'Jij als bestuurder — jij blijft verantwoordelijk voor het handhaven van een veilige volgafstand te allen tijde',
          ar: 'أنت كسائق — تظل مسؤولا عن الحفاظ على مسافة أمان آمنة في جميع الأوقات',
        },
      },
      {
        id: 'q-adas-19o3',
        text: {
          en: 'Neither — ADAS failures are classified as unavoidable accidents',
          nl: 'Geen van beiden — ADAS-storingen worden geclassificeerd als onvermijdelijke ongelukken',
          ar: 'لا أحد — تصنف أعطال ADAS على أنها حوادث لا يمكن تجنبها',
        },
      },
    ],
    correctAnswerId: 'q-adas-19o2',
    explanation: {
      en: 'Driver assistance systems do not transfer legal responsibility to the manufacturer. As the driver, you are always responsible for safe vehicle control. Maintain your own safe following distance and do not rely solely on ACC.',
      nl: 'Rijassistentiesystemen dragen de wettelijke verantwoordelijkheid niet over aan de fabrikant. Als bestuurder ben je altijd verantwoordelijk voor veilige voertuigbeheersing. Houd je eigen veilige volgafstand aan en vertrouw niet uitsluitend op ACC.',
      ar: 'لا تنقل أنظمة مساعدة السائق المسؤولية القانونية إلى الشركة المصنعة. بوصفك سائقا، أنت دائما مسؤول عن التحكم الآمن في المركبة. حافظ على مسافة أمان آمنة خاصة بك ولا تعتمد على ACC وحده.',
    },
  },
  {
    id: 'q-adas-20',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'When must you always be capable of taking full manual control of your vehicle, regardless of which ADAS systems are active?',
      nl: 'Wanneer moet je altijd in staat zijn de volledige handmatige controle over je voertuig over te nemen, ongeacht welke ADAS-systemen actief zijn?',
      ar: 'متى يجب أن تكون دائما قادرا على التحكم اليدوي الكامل في سيارتك بغض النظر عن أنظمة ADAS النشطة؟',
    },
    options: [
      {
        id: 'q-adas-20o1',
        text: {
          en: 'Only when ADAS systems give a warning signal',
          nl: 'Alleen wanneer ADAS-systemen een waarschuwingssignaal geven',
          ar: 'فقط عندما تعطي أنظمة ADAS إشارة تحذير',
        },
      },
      {
        id: 'q-adas-20o2',
        text: {
          en: 'At all times — driver assistance systems can fail at any moment without warning',
          nl: 'Te allen tijde — rijassistentiesystemen kunnen op elk moment zonder waarschuwing uitvallen',
          ar: 'في جميع الأوقات — يمكن أن تفشل أنظمة مساعدة السائق في أي لحظة دون سابق إنذار',
        },
      },
      {
        id: 'q-adas-20o3',
        text: {
          en: 'Only at speeds above 100 km/h where risks are higher',
          nl: 'Alleen bij snelheden boven 100 km/u waar de risico\'s hoger zijn',
          ar: 'فقط عند سرعات تتجاوز 100 كم/ساعة حيث تكون المخاطر أعلى',
        },
      },
    ],
    correctAnswerId: 'q-adas-20o2',
    explanation: {
      en: 'ADAS systems can fail without warning due to sensor degradation, software errors, weather, or unexpected road situations. You must always be alert and ready to take full manual control immediately. This is a fundamental principle of driving with ADAS.',
      nl: 'ADAS-systemen kunnen zonder waarschuwing uitvallen door sensordegradatie, softwarefouten, weer of onverwachte verkeerssituaties. Je moet altijd alert zijn en klaar om onmiddellijk de volledige handmatige controle over te nemen. Dit is een fundamenteel principe van rijden met ADAS.',
      ar: 'يمكن أن تفشل أنظمة ADAS دون سابق إنذار بسبب تدهور أجهزة الاستشعار أو أخطاء البرنامج أو الطقس أو مواقف الطريق غير المتوقعة. يجب أن تكون دائما يقظا ومستعدا للتحكم اليدوي الكامل فورا. هذا مبدأ أساسي في القيادة مع ADAS.',
    },
  },

  // --- ABS ---
  {
    id: 'q-adas-21',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'You need to brake hard in an emergency on a road with ABS. What is the correct technique?',
      nl: 'Je moet hard remmen in een noodsituatie op een weg met ABS. Wat is de juiste techniek?',
      ar: 'تحتاج إلى فرملة قوية في حالة طارئة على طريق مجهز بـABS. ما هي التقنية الصحيحة؟',
    },
    options: [
      {
        id: 'q-adas-21o1',
        text: {
          en: 'Pump the brakes rapidly to prevent wheel lock',
          nl: 'Pomp de remmen snel om blokkering van de wielen te voorkomen',
          ar: 'اضغط على الفرامل بسرعة لمنع قفل العجلات',
        },
      },
      {
        id: 'q-adas-21o2',
        text: {
          en: 'Press the brake pedal firmly and hold — ABS prevents wheel lock and you can steer',
          nl: 'Druk stevig op het rempedaal en houd het ingedrukt — ABS voorkomt blokkering van de wielen en je kunt sturen',
          ar: 'اضغط على دواسة الفرامل بقوة وأبقها مضغوطة — ABS يمنع قفل العجلات ويمكنك التوجيه',
        },
      },
      {
        id: 'q-adas-21o3',
        text: {
          en: 'Brake gently to avoid triggering ABS, which can increase stopping distance',
          nl: 'Rem voorzichtig om activering van ABS te vermijden, wat de remafstand kan vergroten',
          ar: 'فرم بلطف لتجنب تشغيل ABS الذي قد يزيد من مسافة التوقف',
        },
      },
    ],
    correctAnswerId: 'q-adas-21o2',
    explanation: {
      en: 'With ABS, press the brake pedal hard and keep it pressed. The system automatically pulses the brakes to prevent wheel lock. Unlike pre-ABS driving, you do not need to pump the brake. The vibration you feel through the pedal is normal — keep pressing.',
      nl: 'Met ABS druk je hard op het rempedaal en houd je het ingedrukt. Het systeem pulseert de remmen automatisch om blokkering te voorkomen. In tegenstelling tot rijden zonder ABS hoef je de rem niet te pompen. De trillingen via het pedaal zijn normaal — blijf drukken.',
      ar: 'مع ABS، اضغط على دواسة الفرامل بقوة وأبقها مضغوطة. ينبض النظام الفرامل تلقائيا لمنع قفل العجلات. على عكس القيادة قبل ABS، لا تحتاج إلى ضخ الفرامل. الاهتزاز الذي تشعر به عبر الدواسة طبيعي — استمر في الضغط.',
    },
  },

  // --- EU mandatory systems ---
  {
    id: 'q-adas-24',
    subject: 'ADAS & Safety Systems',
    text: {
      en: 'Since July 2024, which safety systems are mandatory on all new passenger cars sold in the EU?',
      nl: 'Welke veiligheidssystemen zijn sinds juli 2024 verplicht op alle nieuwe personenauto\'s die in de EU worden verkocht?',
      ar: 'منذ يوليو 2024، ما هي أنظمة السلامة الإلزامية في جميع السيارات الركاب الجديدة المباعة في الاتحاد الأوروبي؟',
    },
    options: [
      {
        id: 'q-adas-24o1',
        text: {
          en: 'Autonomous driving capability and self-parking',
          nl: 'Zelfrijdende mogelijkheid en zelfparkeren',
          ar: 'قدرة القيادة الذاتية والركن الذاتي',
        },
      },
      {
        id: 'q-adas-24o2',
        text: {
          en: 'ISA, AEB, LDW, drowsiness detection, reversing detection, and eCall among others',
          nl: 'ISA, AEB, LDW, slaperigheidsdetectie, achteruitrijdetectie en eCall onder andere',
          ar: 'ISA وAEB وLDW والكشف عن النعاس والكشف عن الرجوع للخلف وeCall من بين أنظمة أخرى',
        },
      },
      {
        id: 'q-adas-24o3',
        text: {
          en: 'Only ABS and ESP — newer systems remain optional',
          nl: 'Alleen ABS en ESP — nieuwere systemen blijven optioneel',
          ar: 'ABS وESP فقط — الأنظمة الأحدث لا تزال اختيارية',
        },
      },
    ],
    correctAnswerId: 'q-adas-24o2',
    explanation: {
      en: 'EU Regulation 2019/2144 mandated that from July 2024, all new car types must include: ISA, AEB (for pedestrians and cyclists), LDW, drowsiness and attention detection, reversing detection, event data recorder, and eCall. ABS and ESC were already mandatory earlier.',
      nl: 'EU-verordening 2019/2144 bepaalt dat vanaf juli 2024 alle nieuwe autotypen moeten bevatten: ISA, AEB (voor voetgangers en fietsers), LDW, slaperigheids- en aandachtsdetectie, achteruitrijdetectie, event data recorder en eCall. ABS en ESC waren al eerder verplicht.',
      ar: 'اشترطت لائحة الاتحاد الأوروبي 2019/2144 أنه اعتبارا من يوليو 2024، يجب أن تتضمن جميع أنواع السيارات الجديدة: ISA وAEB (للمشاة وراكبي الدراجات) وLDW والكشف عن النعاس والانتباه والكشف عن الرجوع للخلف ومسجل بيانات الحوادث وeCall. كان ABS وESC إلزاميين في وقت سابق.',
    },
  },
];
